import { createSelector, select } from "@ngrx/store";
import { selectAppState } from "./app.selector";
import { AppState } from "../app.state";
import { eventAdapter } from "../adapters/events.adapter";

const selectEventStore = createSelector(
    selectAppState,
    (state: AppState) => state.upcomingEvents
)

export const selectAllUpcomingEventsFlag = createSelector(
    selectEventStore,
    state => state.allUpcoming
)

export const {
  selectIds: selectEventIds,
  selectEntities: selectEventEntities,
  selectAll: selectAllEvents,
  selectTotal: selectTotalEvents,
} = eventAdapter.getSelectors(createSelector(selectEventStore, state => state.events));

export const selectEvent = (eventRef:string) => createSelector(
    selectAllEvents,
    state => state.find(x => x.eventLink === eventRef)
)

export const selectAllEventsBySystem = (systemRef:string) => createSelector(
    selectEventStore,
    selectAllEvents,
    (state,events) => events.filter(x => x.eventHost.eventSystem.systemRef === systemRef)
)